import { Funder } from './funder';
import { User } from './user';

export class ServiceType {
  service_type_code!: string;
  name!: string;
  description!: string;
  limit_type!: string;
  limit_value!: number;
  service_type_claims_type!: string;
  status!: string;
  date_deleted?: number | null;
  uuid!: string;
  user_uuid!: string;
  date_created!: number;
  date_updated!: number;

  user?: User;

  constructor(data: any) {
    this.service_type_code = data.service_type_code;
    this.name = data.name;
    this.description = data.description;
    this.limit_type = data.limit_type;
    this.limit_value = data.limit_value;
    this.service_type_claims_type = data.service_type_claims_type;
    this.status = data.status;
    this.date_deleted = data.date_deleted;
    this.uuid = data.uuid;
    this.user_uuid = data.user_uuid;
    this.date_created = data.date_created;
    this.date_updated = data.date_updated;

    if (data.user) {
      this.user = new User(data.user);
    }
  }
}
